const crypto = require('crypto');
import {Marshaller} from '@aws/dynamodb-auto-marshaller';
export default {

  data(){
      return {


        //bookmark data object

        currentBookmark:{
              time:'0:00',
              label:'',
              image:''

          },



          //transcrpt data objs
        H5PObject:{},
        currentQuiz:{},
        currentTextInteraction:{},


      }

  },

	methods: {


   showTranscriptCurrentWord(timestamp){


        //this listener needs to also handle listewning to other parts of transcript

        var playuntil = this.$store.state.transcriptEdit.transcript_segment_end;
        var listenmode = this.$store.state.transcriptEdit.listenmode;

        //////console.log('this.playuntil: ' + playuntil)

        if(playuntil != 0){

            if(timestamp >= playuntil){
              this.pauseCurrentVideo();
              if(listenmode == 'segment'){

                  var tempobj = this.$store.state.transcriptEdit;
                  tempobj.transcript_segment_end = 0;
                  tempobj.listenmode = 'transcript';
                  this.$store.commit('transcriptEdit', tempobj);
              }


            }
        }

        if(listenmode == 'transcript'){

        //let displayWords = [...document.querySelectorAll("[data-start-time]")].filter(x=>x.attributes["data-start-time"].value > this.$store.state.currentShuttle.video_start_at)
        //onsole.log(confidenceWords["data-confidence"]);

        ////////console.log(displayWords);

        let displayWords = document.querySelectorAll("[data-start-time]");

        for(var element of displayWords){
           ////////console.log(element.getAttribute('data-confidence'));
           var start_time = parseFloat(element.getAttribute('data-time'));
           var end_time = parseFloat(element.getAttribute('data-end-time'));

           ////////console.log("start: " + start_time + " end: " + end_time);
           if(start_time){

            if(timestamp >= start_time && timestamp <= end_time){
                  ////console.log("element.offsetTop: " + element.offsetTop + " start: " + start_time + " end: " + end_time);


                  //var topPos = element.parentElement.offsetTop;
                  if(element.offsetTop > 0){
                  var topPos = element.offsetTop - 50;
                  // only scroll if >1 speaker
                  document.getElementById('content').scrollTop = topPos;
                }


                  element.classList.add("highlight-word");
            } else {
                 element.classList.remove("highlight-word");



            }
          }


        }}


    },



		minTommss(minutes){
	 var sign = minutes < 0 ? "-" : "";
	 var min = Math.floor(Math.abs(minutes));
	 var sec = Math.floor((Math.abs(minutes) * 60) % 60);
	 return sign + (min < 10 ? "0" : "") + min + ":" + (sec < 10 ? "0" : "") + sec;
},



  async renderH5p(target){

        //We are updating the video display, disable controls until the video is actually ready (see H5PVideo Loaded)
        this.$store.commit('H5P', {isDomReady:false,isVideoReady:false}); // maybe run this after the await


        //clear the div
        var foo = document.getElementById(target);
        if(foo){
        while (foo.firstChild) foo.removeChild(foo.firstChild);
      }
        console.log("*** RENDER H5P CALLED!!! ***");
        this.trackerSession = 'edit_' + this.$store.state['auth'].event_id + '_' + this.$store.state.currentShuttle.id ;


        this.dynamicH5p = await this.generateDynamicH5p(false);

       var  shuttleInitObj = {
            callXapi:false,
            studio:true,
            target: this.h5pdiv,
            shuttleId: this.h5pdiv,
            customerId: this.$store.state['auth'].sub,
            userDataUrl: this.$store.state.uri.api_base_uri + "track/user-data/" + this.trackerSession + '?data_type=:dataType&subContentId=:subContentId',
            xapiUrl: this.$store.state.uri.api_base_uri + "track/xapi/" + this.trackerSession,
            finishUrl: this.$store.state.uri.api_base_uri + "track/finish/" + this.trackerSession+ "?data_type=:dataType&subContentId=:subContentId",
            user:{
                externalId:this.$store.state['auth'].sub,
                firstName:this.$store.state['auth'].username,
                lastName:'',
                email: this.$store.state['auth'].email

            },
            //xAPIDispatch:this.trackXAPI,
            content:this.dynamicH5p,
            initCallback:this.H5PObjectLoaded

        }


       // ////console.log(shuttleInitObj)



          this.$nextTick(function () {
              //////console.log(document.getElementById(this.h5pdiv));




              shuttleInit(shuttleInitObj);




          });



  },




//this function dispatched when the h5p content is loaded. should take into account any tab needs from here
H5PObjectLoaded(){
    ////console.log('H5P LOADED!')

    this.H5PObject = H5P.instances[0];
    //this.H5PObject = H5P.instances.find(x => x.contentId === this.$store.state.currentShuttle.id)
    ////console.log(this.H5PObject);

    this.H5PObject.video.on('loaded',this.H5PVideoLoaded);



},

// After h5p is ready, makesure the video is ready
H5PVideoLoaded(){

  ////console.log('H5P Video LOADED')
  this.$store.commit('H5P', {isDomReady:true,isVideoReady:true});



        // handle multiple tabs situations here so multiple listeners not added to the objext

        var vm = this;

        switch(this.$store.state.currentEditTab){

            case 'bookmark_tab':

              //we want video to go to the last bookmark if any
              var bookmarksList = this.$store.state.currentShuttle.bookmarks !== undefined ? this.$store.state.currentShuttle.bookmarks : [];
              if(bookmarksList.length > 0){
                  ////console.log('bookmark seeking');
                  this.seekCurrentVideo(bookmarksList[bookmarksList.length-1].time);

              }
              this.H5PObject = H5P.instances[0];
              this.H5PObject.video.on('videoTimeUpdate',function(e){vm.setBookmarkTime(e.data)});

            break;

            case 'transcript_tab':
              this.H5PObject = H5P.instances[0];
               this.H5PObject.video.on('videoTimeUpdate',function(e){vm.showTranscriptCurrentWord(e.data)});

            break;

            case 'quiz_tab':

            if(this.currentQuiz.duration){
             this.seekCurrentVideo(this.currentQuiz.duration.from);
            }
            case 'text_tab':

            if(this.currentTextInteraction.duration){
             this.seekCurrentVideo(this.currentTextInteraction.duration.from);
            }



            break;

        }


        var start_activity_at = this.$store.state.currentShuttle.video_start_at !== undefined ? this.$store.state.currentShuttle.video_start_at : 0;



        var activty_duration = this.getVideoDuration() - start_activity_at;


        this.$store.commit('currentShuttleDuration', parseInt(activty_duration));


},


    /* async loadH5p(element){
        try{
          //H5P.externalDispatcher.off('domChanged', vm.H5PDomReady);
        } catch(e){}

        //var div = this.$refs[element];
        var div = document.getElementById(element);
        var id = div.id;
        ////////console.log(id);
        while(div.firstChild){
            div.removeChild(div.firstChild);
        }
        var vm = this;
        (function($) {
           $(function() {
                ////////console.log(vm.default_context_json)

             $('.' + element).h5p({
                  id:'shuttle',
                  frameJs: '/js/h5p-standalone-frame.js',
                  frameCss: '/styles/h5p.css',
                  h5pContent: 'https://shuttle.authenticlearninglabs.com/h5p/base',
                  libraryPath: vm.$store.state.uri.h5p_library,
                  contentOverride: vm.dynamicH5p,
                  h5pOverride: vm.$store.state.uri.h5p_json_default
                });
              });

             //H5P.externalDispatcher.on('domChanged', null);



            }


            )(H5P.jQuery,H5P.EventDispatcher,H5P.InteractiveVideo);





          return true;


      },
*/



    fmtMSS(s){return(s-(s%=60))/60+(9<s?':':':0')+Math.round(s)},

		  hmsToSecondsOnly(str) {

        console.log(str);


    var p = str.split(':'),
        s = 0, m = 1;

    while (p.length > 0) {
        s += m * parseInt(p.pop(), 10);
        m *= 60;
    }

    return s;
},

		getCurrentFrameImage(source){

      //////console.log('getCurrentFrameImage')
			this.pauseCurrentVideo();

			var ret = {success:false,data:''}

			 var canvas = document.getElementById(source);
  			var video = document.getElementsByTagName("video")[0];

			//get the height and width of the video so we can properly size the canvas

			var video_height = video.videoHeight;
			var video_width = video.videoWidth;

			canvas.height = video_height;
			canvas.width = video_width;


			  if (video.paused) {
			      canvas.getContext('2d').drawImage(video, 0, 0);
			      var dataUrl = canvas.toDataURL();
			      //document.getElementById(target).src = dataUrl;
			      ////////console.log(dataUrl)

			      ret.success = true;
			      ret.data = dataUrl;
			      return ret;

			  } else {

			  		return ret;

			  }

		},


      previewShuttle(id){
         this.$router.push({path:'/studio/preview/' + id});

      },

		updateDrawer:function(val){
				this.$store.commit('drawerState', !this.$store.state.drawer);
				//////console.log(!this.$store.state.drawer)
				return this.$store.state.drawer;

		},

		getDrawer:function(val){

				//return this.$store.state.drawer;
		},

	  hasShuttles(){

	  		var hasshuttles = false;


	  		 if(
              this.$store.state.currentShuttle.hasOwnProperty('speakers')
              ||
              this.$store.state.currentShuttle.hasOwnProperty('presentations')
              ||
              this.$store.state.currentShuttle.hasOwnProperty('transcriptPath')
              ||
              this.$store.state.currentShuttle.hasOwnProperty('addons')
            )
            {
              hasshuttles = true;
          	}

          	return hasshuttles;

	  },


      async downloadShuttle(){

          var downlodpath = this.$store.state.uri.app_base_uri + '/uploads/' + this.$store.state.currentShuttle.customer_id + '/shuttles/' + this.$store.state.currentShuttle.id + '/package/' + this.$store.state.currentShuttle.package;

          ////console.log(downlodpath);
         document.location.href = downlodpath;

      },

    hasTranscriptJob(state){



        var hasJob = false
        if(this.$store.state.currentShuttle.transcribe){
          if(this.$store.state.currentShuttle.transcribe.TranscriptionJob ){
              hasJob = true
          }
        }


        if(this.$store.state.currentShuttle.transcribejob){
           hasJob = true

        }


        return hasJob;



    },

    getVideoCurrentTime(){

    	var videoCurrentTime = 0;
    	try{
    		this.H5PObject = H5P.instances[0];
    		videoCurrentTime = this.H5PObject.video.getCurrentTime()

    	}catch(e){}

    	return videoCurrentTime;
    },


    getVideoDuration(){

      var videoCurrentTime = 0;
      try{
        this.H5PObject = H5P.instances[0];
        videoCurrentTime = this.H5PObject.video.getDuration()

      }catch(e){}

      return videoCurrentTime;
    },



    playCurrentVideo(){


    	try{
    		this.H5PObject = H5P.instances[0];

        //this.H5PObject.video.play()

    	}catch(e){}


    },
    pauseCurrentVideo(){


    	try{
    		this.H5PObject = H5P.instances[0];
    		this.H5PObject.video.pause()

    	}catch(e){}


    },

       seekCurrentVideo(timestamp){

       ////////console.log('SEEK VIDEO TO: ' + timestamp)
    	try{
    		this.H5PObject = H5P.instances[0];
    		//H5PObject.timeUpdate(timestamp);
         this.H5PObject.timeUpdate(timestamp);
       this.H5PObject.video.seek(timestamp);


    	}catch(e){

        ////console.log('ERROR SEEKING VIDEO: ' + timestamp)

      }


    },

    getVideoFontSize(){


      try{
        this.H5PObject = H5P.instances[0];
        return parseInt(this.H5PObject.$videoWrapper.css('font-size'), 10);

      }catch(e){
          return 0;

      }


    },

    getVideoWidth(){


      try{
        this.H5PObject = H5P.instances[0];
        return parseInt(this.H5PObject.$videoWrapper.width());

      }catch(e){
          return 0;

      }


    },

    getVideoHeight(){


      try{
        this.H5PObject = H5P.instances[0];
        return parseInt(this.H5PObject.$videoWrapper.height());

      }catch(e){
          return 0;

      }


    },

    getVideoAspect(){


      try{

        return (this.getVideoHeight()/this.getVideoWidth())

      }catch(e){
          return 0;

      }


    },



    getpToEm(){


      try{
        var pToEm = (this.getVideoWidth()/ this.getVideoFontSize()) / 100;
        return pToEm;

      }catch(e){
          return 0;

      }


    },






   getshuttleTranscriptSpeakerMap(local){

        var speakerMap = [];

             if(this.$store.state.currentShuttle.hasOwnProperty('speakers')){

              //////console.log('transcript has speakers')

                for(var speaker of this.$store.state.currentShuttle.speakers ){


                    if(speaker.hasOwnProperty('transcript_map')){
                         //////console.log('transcript has transcript map')

                          if(speaker.transcript_map.length > 0){

                              for(var map of speaker.transcript_map){

                                  var imgurl = speaker.img_url
                                  if(local){
                                      imgurl = 'images\/' + speaker.img
                                  }

                                  var mapObj = {
                                    id:map.id,
                                    name:speaker.display_name,
                                    image:imgurl
                                  }


                                  speakerMap.push(mapObj)

                              }



                          }

                    }


                }

             }

           return speakerMap;


    },




	 async generateDynamicH5p(preview,mode){


        if(!mode){

          mode = 'simpatico'
        }


          var vm=this;

          let dynamicH5p = JSON.parse(JSON.stringify(vm.$store.state.default_context_json));
          let contentH5p = JSON.parse(JSON.stringify(vm.$store.state.default_context_json));


          var editMode = false;
          //some tabs we are just ediing h5p features, so remove them
          if ((vm.$store.state.currentEditTab == 'text_tab'
          	  || vm.$store.state.currentEditTab == 'quiz_tab'
              || vm.$store.state.currentEditTab == 'video_tab'
              || vm.$store.state.currentEditTab == 'bookmark_tab'
              || vm.$store.state.currentEditTab == 'presenter_tab'
              || vm.$store.state.currentEditTab == 'options_tab')


            ){
              editMode = true;

          }

          if(preview){
            editMode = false;
          }



          if(vm.$store.state.currentShuttle.hasOwnProperty('title')){


              //only show this on the video_optoons tab otherwise it gets in the way of interactions when editing.
              if((editMode && vm.$store.state.currentEditTab == 'video_tab') || preview){
                  dynamicH5p.interactiveVideo.video.startScreenOptions.title = vm.$store.state.currentShuttle.title;
              }




              contentH5p.interactiveVideo.video.startScreenOptions.title = vm.$store.state.currentShuttle.title;

          }


          if(vm.$store.state.currentShuttle.hasOwnProperty('description')){

              if((editMode && vm.$store.state.currentEditTab == 'video_tab') || preview){
                dynamicH5p.interactiveVideo.video.startScreenOptions.shortStartDescription = vm.$store.state.currentShuttle.description;
              }

              contentH5p.interactiveVideo.video.startScreenOptions.shortStartDescription = vm.$store.state.currentShuttle.description;

          }

           if(vm.$store.state.currentShuttle.hasOwnProperty('video')){

              dynamicH5p.interactiveVideo.video.files[0].path = vm.$store.state.uri.app_base_uri + '/uploads/' + vm.$store.state.currentShuttle.customer_id + '/shuttles/' + vm.$store.state.currentShuttle.id + '/video/' + vm.$store.state.currentShuttle.video;

              contentH5p.interactiveVideo.video.files[0].path = vm.$store.state.uri.app_base_uri + '/uploads/' + vm.$store.state.currentShuttle.customer_id + '/shuttles/' + vm.$store.state.currentShuttle.id + '/video/' + vm.$store.state.currentShuttle.video;



          }

          if (vm.$store.state.currentShuttle.hasOwnProperty('userVideoURL')) {
            dynamicH5p.interactiveVideo.video.files[0].path = vm.$store.state.currentShuttle.userVideoURL;
            contentH5p.interactiveVideo.video.files[0].path = vm.$store.state.currentShuttle.userVideoURL;
          }

          if (vm.$store.state.currentShuttle.hasOwnProperty('zoomVideoURL')) {
            dynamicH5p.interactiveVideo.video.files[0].path = vm.$store.state.uri.app_base_uri + '/uploads/' + vm.$store.state.currentShuttle.customer_id + '/shuttles/' + vm.$store.state.currentShuttle.id + '/video/zoom_upload.mp4';
            contentH5p.interactiveVideo.video.files[0].path = vm.$store.state.uri.app_base_uri + '/uploads/' + vm.$store.state.currentShuttle.customer_id + '/shuttles/' + vm.$store.state.currentShuttle.id + '/video/zoom_upload.mp4';
          }

           if(vm.$store.state.currentShuttle.hasOwnProperty('video_poster_image')){

              var poster = {}
              poster.path = vm.$store.state.currentShuttle.video_poster_image;
              poster.mime = 'image\/png';

              if((editMode && vm.$store.state.currentEditTab == 'video_tab')  || preview){
                dynamicH5p.interactiveVideo.video.startScreenOptions.poster = poster;
              }


              var content_poster = {}
              content_poster.path = 'images\/' + vm.$store.state.currentShuttle.video_poster_image.split("/").pop();
              content_poster.mime = 'image\/png';


              contentH5p.interactiveVideo.video.startScreenOptions.poster = content_poster;

          }


          if(vm.$store.state.currentShuttle.hasOwnProperty('vttPath')){

                var textTracks = {
                                  videoTrack: [{
                                    label: "English",
                                    kind: "subtitles",
                                    srcLang: "en",
                                    track: {
                                       path:vm.$store.state.uri.app_base_uri +vm.$store.state.currentShuttle.vttPath,
                                      mime: "text\/plain",
                                      copyright: {
                                        license: "U"
                                      }
                                    }
                                  }]
                                }

                 if(preview){
                 dynamicH5p.interactiveVideo.video.textTracks = textTracks;
                    }


                    if(mode == 'simpatico'){

                             var localTracks = {
                                  videoTrack: [{
                                    label: "English",
                                    kind: "subtitles",
                                    srcLang: "en",
                                    track: {
                                       path:'transcript\/edit\/' + vm.$store.state.currentShuttle.vttPath.split("/").pop(),
                                      mime: "text\/plain",
                                      copyright: {
                                        license: "U"
                                      }
                                    }
                                  }]
                                }



                    } else {

                             var localTracks = {
                                  videoTrack: [{
                                    label: "English",
                                    kind: "subtitles",
                                    srcLang: "en",
                                    track: {
                                       path:'files\/' + vm.$store.state.currentShuttle.vttPath.split("/").pop(),
                                      mime: "text\/plain",
                                      copyright: {
                                        license: "U"
                                      }
                                    }
                                  }]
                                }


                    }


                  contentH5p.interactiveVideo.video.textTracks = localTracks;




          }





          //CREATE SHUTTLE ASSESTS IF NEEDED
          var hasshuttles = this.hasShuttles();

          //////console.log('dynamicH5p has shuttles? ' + hasshuttles)

          if(hasshuttles){

              // we dont want to show shuttle items when adding interactions such as
              dynamicH5p.interactiveVideo.assets = {};
              //if(!editMode ){
                dynamicH5p.interactiveVideo.assets.shuttles = [];
              //}
              contentH5p.interactiveVideo.assets = {};
              contentH5p.interactiveVideo.assets.shuttles = [];

          } else {

              delete dynamicH5p.interactiveVideo.assets.shuttles;
              delete contentH5p.interactiveVideo.assets.shuttles;
          }


          //BUILD ADDON
          if (hasshuttles && vm.$store.state.currentShuttle.hasOwnProperty('addons')) {
            if (vm.$store.state.currentShuttle.addons.length > 0) {
              for (let a = 0; a < vm.$store.state.currentShuttle.addons.length; a++) {
                  let addonObj = {
                    name: 'Addon',
                    type: 'shuttle.addon',
                    id: 'shuttle.addon',
                    addon: {
                      path: vm.$store.state.uri.app_base_uri
                                  + '/uploads/' + vm.$store.state.auth.sub
                                  + '/shuttle-template-configs/'
                                  + vm.$store.state.currentShuttle.addons[a] + '.json',
                      mime: 'text\/plain'
                  }
                };

                if (preview) { // (editMode && vm.$store.state.currentEditTab == 'video_tab')) {
                  dynamicH5p.interactiveVideo.assets.shuttles.push(addonObj);
                }
                contentH5p.interactiveVideo.assets.shuttles.push(addonObj);
                //addonObj.addon.path = addonObj.addon.path.split('/').pop();
            }
          }
        }

          //BUILD SHUTTLE TRANSCRIPT
          if(hasshuttles && vm.$store.state.currentShuttle.hasOwnProperty('transcriptPath')){


              var transcriptObj = {
                name:'Transcript',
                type:'shuttle.transcript',
                  id:'shuttle.transcript',
                  transcript:{
                    path:vm.$store.state.uri.app_base_uri +vm.$store.state.currentShuttle.transcriptPath,
                    mime:'text\/plain'
                  }

              }


              var speakerMap = this.getshuttleTranscriptSpeakerMap();
              ////////console.log(speakerMap);

             if(speakerMap.length > 0){

                transcriptObj.transcript.speakerMap = speakerMap;

             }


             if(preview){
              dynamicH5p.interactiveVideo.assets.shuttles.push(transcriptObj);
            }



            if(mode == 'simpatico'){

              var transcriptObjLocal = {
                name:'Transcript',
                type:'shuttle.transcript',
                  id:'shuttle.transcript',
                  transcript:{
                      path:'transcript\/edit\/'  + vm.$store.state.currentShuttle.transcriptPath.split("/").pop(),
                    mime:'text\/plain'
                  }

              }

            } else {


              var transcriptObjLocal = {
                name:'Transcript',
                type:'shuttle.transcript',
                  id:'shuttle.transcript',
                  transcript:{
                    path:'files\/'  + vm.$store.state.currentShuttle.transcriptPath.split("/").pop(),
                    mime:'text\/plain'
                  }

              }

            }

              speakerMap = [];

              speakerMap = this.getshuttleTranscriptSpeakerMap(true);

             if(speakerMap.length > 0){

                transcriptObjLocal.transcript.speakerMap = speakerMap;

             }

             //////console.log(transcriptObjLocal);


             contentH5p.interactiveVideo.assets.shuttles.push(transcriptObjLocal);


          }

            //BUILD SHUTTLE SPEAKERS
            if(hasshuttles && vm.$store.state.currentShuttle.hasOwnProperty('speakers')){

                var spkobj = {
                  name:'Speakers',
                  type:'shuttle.speakers',
                  id:'shuttle.speakers',
                  speakers:[]
                };

                var spkobjlocal = {
                  name:'Speakers',
                  type:'shuttle.speakers',
                  id:'shuttle.speakers',
                  speakers:[]
                };


                for(var speaker of vm.$store.state.currentShuttle.speakers ){


                    var spk = {
                        id:speaker.id,
                        name:speaker.display_name,
                        image:speaker.img_url,
                        start_time:speaker.start_time,
                        description:speaker.description,
                        disclosure:speaker.disclosure

                    }

                    var spklocal = {
                        id:speaker.id,
                        name:speaker.display_name,
                        image:'images\/' + speaker.img,
                        start_time:speaker.start_time,
                        description:speaker.description,
                        disclosure:speaker.disclosure

                    }


                    spkobj.speakers.push(vm.cleanObjectDynamo(spk));
                    spkobjlocal.speakers.push(vm.cleanObjectDynamo(spklocal));

                }

              if((editMode && vm.$store.state.currentEditTab == 'presenter_tab') || preview){
                dynamicH5p.interactiveVideo.assets.shuttles.push(spkobj);
                }
          contentH5p.interactiveVideo.assets.shuttles.push(spkobjlocal);

          }



          dynamicH5p.interactiveVideo.assets.interactions = [];
          contentH5p.interactiveVideo.assets.interactions = [];

          /*Interactions*/

         if(vm.$store.state.currentShuttle.hasOwnProperty('textInteractions')){

         	for(var i of vm.$store.state.currentShuttle.textInteractions){

             //////console.log('text interaction')

              if((editMode && vm.$store.state.currentEditTab == 'text_tab') || preview){

                dynamicH5p.interactiveVideo.assets.interactions.push(i);

              }

              contentH5p.interactiveVideo.assets.interactions.push(i);
         	}

         }

         if(vm.$store.state.currentShuttle.hasOwnProperty('quizInteractions')){

         	for(var i of vm.$store.state.currentShuttle.quizInteractions){

             //////console.log('text interaction')

              if((editMode && vm.$store.state.currentEditTab == 'quiz_tab') || preview){

                dynamicH5p.interactiveVideo.assets.interactions.push(i);

              }

              contentH5p.interactiveVideo.assets.interactions.push(i);
         	}

         }



          /*BOOKMARKS*/

           if(vm.$store.state.currentShuttle.hasOwnProperty('bookmarks')){


              dynamicH5p.interactiveVideo.assets.bookmarks = [];
              contentH5p.interactiveVideo.assets.bookmarks = [];
              let tempbookmarks = Object.assign([],vm.$store.state.currentShuttle.bookmarks);

              for(var bookmark of tempbookmarks){

               if((editMode && vm.$store.state.currentEditTab == 'bookmark_tab') || preview){
                  dynamicH5p.interactiveVideo.assets.bookmarks.push(vm.cleanObjectDynamo(bookmark));
                }
                  let tempBookmark = Object.assign({},bookmark)
                  if(tempBookmark.image){
                  tempBookmark.image = 'images\/' + bookmark.image.split("/").pop()
              }
                  contentH5p.interactiveVideo.assets.bookmarks.push(vm.cleanObjectDynamo(tempBookmark));
                  //bookmark.image = 'images\/' + bookmark.image.split("/").pop()
                  //contentH5p.interactiveVideo.assets.bookmarks.push(vm.cleanObjectDynamo(bookmark));


              }


          }

          /*OVERRIDES*/
          dynamicH5p.override = {}
          contentH5p.override = {}


            contentH5p.override.autoplay = vm.$store.state.currentShuttle.video_autoplay !== undefined ? vm.$store.state.currentShuttle.video_autoplay : false;
            contentH5p.override.loop = vm.$store.state.currentShuttle.video_loop !== undefined ? vm.$store.state.currentShuttle.video_loop : false;
            contentH5p.override.showBookmarksmenuOnLoad= vm.$store.state.currentShuttle.video_bookmarks_open !== undefined ? vm.$store.state.currentShuttle.video_bookmarks_open : false;
            contentH5p.override.hideTranscript = !!vm.$store.state.currentShuttle.hideTranscript;
            contentH5p.override.videoDefaultWide = !!vm.$store.state.currentShuttle.videoDefaultWide;

            contentH5p.override.showRewind10 = vm.$store.state.currentShuttle.video_rewind_10 !== undefined ? vm.$store.state.currentShuttle.video_rewind_10 : false;
            contentH5p.override.preventSkipping= vm.$store.state.currentShuttle.video_prevent_skipping !== undefined ? vm.$store.state.currentShuttle.video_prevent_skipping : false;
            contentH5p.override.showPlaybackRate = vm.$store.state.currentShuttle.showPlaybackRate !== undefined ? vm.$store.state.currentShuttle.showPlaybackRate : false;

            contentH5p.override.showLearnerNotes = vm.$store.state.currentShuttle.showLearnerNotes !== undefined ? vm.$store.state.currentShuttle.showLearnerNotes : false;


            contentH5p.override.startVideoAt= vm.$store.state.currentShuttle.video_start_at !== undefined ? vm.$store.state.currentShuttle.video_start_at : 0;


            contentH5p.override.enablePopup = vm.$store.state.currentShuttle.enablePopup !== undefined ? vm.$store.state.currentShuttle.enablePopup : false;
            contentH5p.override.popupOccurrences = vm.$store.state.currentShuttle.popupOccurrences !== undefined ? vm.$store.state.currentShuttle.popupOccurrences : 0;
            contentH5p.override.popupHr = vm.$store.state.currentShuttle.popupHr !== undefined ? vm.$store.state.currentShuttle.popupHr : 0;
            contentH5p.override.popupMin = vm.$store.state.currentShuttle.popupMin !== undefined ? vm.$store.state.currentShuttle.popupMin : 0;
            contentH5p.override.popupSec = vm.$store.state.currentShuttle.popupSec !== undefined ? vm.$store.state.currentShuttle.popupSec : 0;
            contentH5p.override.popupHeader = vm.$store.state.currentShuttle.popupHeader !== undefined ? vm.$store.state.currentShuttle.popupHeader : 'Confirm Currently Active';
            contentH5p.override.popupText = vm.$store.state.currentShuttle.popupText !== undefined ? vm.$store.state.currentShuttle.popupText : 'Click confirm below to indicate you are not idle.';

            contentH5p.override.completion= vm.$store.state.currentShuttle.completion !== undefined ? vm.$store.state.currentShuttle.completion : {"id": "shuttle.video.immediate"};

          

            contentH5p.override.emailQuestions = vm.$store.state.currentShuttle.emailQuestions !== undefined ? vm.$store.state.currentShuttle.emailQuestions : false;
            if (contentH5p.override.emailQuestions) {
              if (vm.$store.state.currentShuttle.adminEmail) {
                contentH5p.override.adminEmail = vm.$store.state.currentShuttle.adminEmail;
              }
            }

            // need to caclulate the total interactivity time.
            var activity_duration = vm.$store.state.currentShuttle.duration;

            contentH5p.override.duration = activity_duration;





            if(preview){
                //we are prviewing the features, so
            dynamicH5p.override.autoplay = vm.$store.state.currentShuttle.video_autoplay !== undefined ? vm.$store.state.currentShuttle.video_autoplay : false;
            dynamicH5p.override.loop = vm.$store.state.currentShuttle.video_loop !== undefined ? vm.$store.state.currentShuttle.video_loop : false;
            dynamicH5p.override.showBookmarksmenuOnLoad= vm.$store.state.currentShuttle.video_bookmarks_open !== undefined ? vm.$store.state.currentShuttle.video_bookmarks_open : false;
            dynamicH5p.override.hideTranscript = !!vm.$store.state.currentShuttle.hideTranscript;
            dynamicH5p.override.videoDefaultWide = !!vm.$store.state.currentShuttle.videoDefaultWide;

            dynamicH5p.override.showRewind10 = vm.$store.state.currentShuttle.video_rewind_10 !== undefined ? vm.$store.state.currentShuttle.video_rewind_10 : false;
            dynamicH5p.override.preventSkipping= vm.$store.state.currentShuttle.video_prevent_skipping !== undefined ? vm.$store.state.currentShuttle.video_prevent_skipping : false;
            dynamicH5p.override.showPlaybackRate = vm.$store.state.currentShuttle.showPlaybackRate !== undefined ? vm.$store.state.currentShuttle.showPlaybackRate : false;
            dynamicH5p.override.startVideoAt= vm.$store.state.currentShuttle.video_start_at !== undefined ? vm.$store.state.currentShuttle.video_start_at : 0;

            dynamicH5p.override.showLearnerNotes = vm.$store.state.currentShuttle.showLearnerNotes !== undefined ? vm.$store.state.currentShuttle.showLearnerNotes : false;


            dynamicH5p.override.enablePopup = vm.$store.state.currentShuttle.enablePopup !== undefined ? vm.$store.state.currentShuttle.enablePopup : false;
            dynamicH5p.override.popupOccurrences = vm.$store.state.currentShuttle.popupOccurrences !== undefined ? vm.$store.state.currentShuttle.popupOccurrences : 0;
            dynamicH5p.override.popupHr = vm.$store.state.currentShuttle.popupHr !== undefined ? vm.$store.state.currentShuttle.popupHr : 0;
            dynamicH5p.override.popupMin = vm.$store.state.currentShuttle.popupMin !== undefined ? vm.$store.state.currentShuttle.popupMin : 0;
            dynamicH5p.override.popupSec = vm.$store.state.currentShuttle.popupSec !== undefined ? vm.$store.state.currentShuttle.popupSec : 0;
            dynamicH5p.override.popupHeader = vm.$store.state.currentShuttle.popupHeader !== undefined ? vm.$store.state.currentShuttle.popupHeader : 'Confirm Currently Active';
            dynamicH5p.override.popupText = vm.$store.state.currentShuttle.popupText !== undefined ? vm.$store.state.currentShuttle.popupText : 'Click confirm below to indicate you are not idle.';

			     dynamicH5p.override.completion= vm.$store.state.currentShuttle.completion !== undefined ? vm.$store.state.currentShuttle.completion : {"id": "shuttle.video.immediate"};


           dynamicH5p.override.emailQuestions = vm.$store.state.currentShuttle.emailQuestions !== undefined ? vm.$store.state.currentShuttle.emailQuestions : false;
            if (dynamicH5p.override.emailQuestions) {
              if (vm.$store.state.currentShuttle.adminEmail) {
                dynamicH5p.override.adminEmail = vm.$store.state.currentShuttle.adminEmail;
              }
            }


           dynamicH5p.override.duration = activity_duration;



            }




         if(!preview && mode != 'h5p'){

         //this.saveShuttle();
         this.$store.commit('currentShuttleH5PContent', contentH5p);
       }


        if(mode == 'h5p'){

            return contentH5p

        } else {
          ////console.log(dynamicH5p);
      		return dynamicH5p;
        }
	 },
      async getUserShuttles(){

          var vm = this;
           //this.$store.commit('global_message', {message:'Loading Your Shuttles' ,color:'info'});

          let path  = vm.$store.state.endpoint.post_customer + '/' +this.$store.state.auth.sub + '/shuttles';
          let userinfo = await this.getData( path,'get');

          var json = {};


          try{
            if(userinfo){
                if(userinfo.hasOwnProperty('Items')){
                    if(userinfo.Items.customer_id){


                        json = userinfo.Items;
                        //console.log(json);
                        //this.$store.commit('global_message', {message:'Shuttles Loaded' ,color:'success'});
                        return json;
                    }

                }
              }
            } catch(e){
                  this.$store.commit('global_message', {message:'Shuttle Load Error' ,color:'error'});


            }

            return json;


      },



    setBookmarkTime(timestamp){
      ////console.log('set bookmark time: ' + this.$store.state.currentEditTab)
      if(this.$store.state.currentEditTab == 'bookmark_tab'){


        this.currentBookmark.time = this.fmtMSS(Math.floor(timestamp));


      }
    },


     async saveShuttle(attributes,showtoast = true){

        if(showtoast){
          this.$store.commit('global_message', {message:'SAVING ' + this.$store.state.currentShuttle.title ,color:'info'});
        }
           var shuttleid = this.$store.state.currentShuttle.id;
           this.$store.state.currentShuttle.lastModified = new Date().toLocaleString();
           this.$store.state.currentShuttle.lastModifiedTimeStamp = new Date().valueOf();
          //get any current shuttles from server just incase updates were made from other users. this way we get the proper in
           await this.$store.dispatch('dynamo', await this.getUserShuttles());

           //now we need to get the index of our current shuttles to update
           let myshuttles = Object.assign([],this.$store.state.dynamo.shuttles);
           var shuttle_index = myshuttles.findIndex(obj => obj.id === shuttleid);

           // brand new shuttle that needs to be saved, not updated
           if (shuttle_index == -1)
            shuttle_index = myshuttles.length;

           //post the shuttle update
           let postshuttle = {};
           postshuttle.shuttle = this.dynamoMarshall(this.$store.state.currentShuttle);
           postshuttle.shuttle_index = shuttle_index;

           if(attributes){
              postshuttle.attributes = attributes

           }


          let path  = this.$store.state.endpoint.post_customer + '/' +this.$store.state.auth.sub + '/shuttle/update';
          let shuttleresponse = await this.getData( path,'post',postshuttle);
          //////console.log(shuttleresponse);
          if(showtoast){
            if(shuttleresponse.Attributes){
                this.$store.commit('global_message', {message:'Shuttle: ' + this.$store.state.currentShuttle.title + ' Saved',color:'success'});

            }else{

              this.$store.commit('global_message', {message:'SAVE ERROR!',color:'error'});
            }

        }

          //this.setEditDisplay()

          //reset the current shuttle store
          await this.$store.dispatch('dynamo', await this.getUserShuttles());

          return shuttleresponse;

      }
}
};
